import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './clients.css'

const clientsData = [
  { id: 1, name: "Self Help Africa", description: "Water system installations and water meter projects.", image: "/images/12.jpeg" },
  { id: 2, name: "Baseflow", description: "Solar-powered water supply system projects.", image: "/images/13.jpeg" },
  { id: 3, name: "Local Community Water Point Committees", description: "Support for community water systems and maintenance planning.", image: "/images/14.jpeg" },
  { id: 4, name: "Private Borehole Owners", description: "Pump installation, repair, and troubleshooting services.", image: "/images/15.jpeg" },
  { id: 5, name: "Water Development Contractors", description: "Pipeline installation, rehabilitation, fabrication, and technical support.", image: "/images/11.jpeg" }
];

function Clients() {
  return (
    <section className="clients-page">
      <Container>
        <div className="clients-hero">
          <div className="clients-hero-left">
            <div className="clients-pill">🤵 OUR CLIENTS</div>
            <h2 className="clients-title">Trusted by Communities & Partners</h2>
            <p className="clients-subtitle">
              We collaborate with NGOs, contractors, committees, and private owners to deliver reliable water infrastructure and support services.
            </p>
            <Link to="/contact" className="clients-cta">Work With Us</Link>
          </div>

          <div className="clients-hero-right" aria-hidden="true">
            <img className="clients-hero-image" src="/images/33.jpg" alt="" />
          </div>
        </div>

        <Row className="clients-grid">
          {clientsData.map((client, idx) => (
            <Col md={6} lg={4} key={client.id} className="clients-col">
              <div className="client-card">
                <div
                  className="client-hover-image"
                  aria-hidden="true"
                  style={{ '--hover-img': `url(${client.image})` }}
                />
                <div className="client-number">{String(idx + 1).padStart(2, '0')}</div>
                <h3 className="client-name">{client.name}</h3>
                <p className="client-desc">{client.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Clients;
